/**
 * Extract both `uuid` (property) and `ruleId` (trade rule) from route params
 * for the TradeRuleShow route retry flow.
 * Returns null if either parameter is absent so retry is disabled.
 * @param {object} props - Route props provided by found-relay.
 * @returns {{uuid: string, ruleId: string}|null} Retry variables or null when a
 *   required param is missing.
 */
const getTradeRuleShowRetryVariables = (props) => {
  const uuid = props?.match?.params?.uuid;
  const ruleId = props?.match?.params?.ruleId;
  if (!uuid || !ruleId) {
    return null;
  }
  return { uuid, ruleId };
};

export default getTradeRuleShowRetryVariables;
